export default function Banner() {
    return (
        <div className="bg-gradient-to-br from-orange-700 via-orange-600 to-amber-600 rounded-t-lg p-12 md:p-16 text-white shadow-xl relative overflow-hidden">
            {/* Decorative background pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 left-0 w-full h-full" style={{
                    backgroundImage: `radial-gradient(circle at 25px 25px, rgba(255,255,255,0.2) 2%, transparent 0%), 
                           radial-gradient(circle at 75px 75px, rgba(255,255,255,0.2) 2%, transparent 0%)`,
                    backgroundSize: '100px 100px'
                }}></div>
            </div>

            <div className="relative z-10">
                {/* Main text */}
                <div className="text-center">
                    <h1 className="text-4xl md:text-6xl font-bold mb-3" style={{fontFamily: 'serif'}}>
                        Shashtipoorthi
                    </h1>
                    <div className="flex items-center justify-center gap-3 mb-4">
                        <div className="h-px w-16 bg-white opacity-60"></div>
                        <p className="text-lg md:text-xl italic opacity-90">Blessing & Renewal Ceremony</p>
                        <div className="h-px w-16 bg-white opacity-60"></div>
                    </div>

                    <p className="text-2xl md:text-3xl font-semibold mb-6">Silvester</p>

                    {/* Decorative bottom border */}
                    <div className="flex justify-center items-center gap-2 mt-6">
                        <div className="w-2 h-2 rounded-full bg-white opacity-60"></div>
                        <div className="w-16 h-px bg-white opacity-60"></div>
                        <div className="w-3 h-3 rounded-full bg-white opacity-80"></div>
                        <div className="w-16 h-px bg-white opacity-60"></div>
                        <div className="w-2 h-2 rounded-full bg-white opacity-60"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}